import React from "react";
import WebContainer from "../../Containers/WebContainer";
import { navigate } from "gatsby-link";

const Index = ({ pathSegments, hideBreadCrumb, secondLayerMenu }) => {
  const [baseLevel, ...subLevels] = pathSegments;
  const handleNavigattion = (index, baseLevel, subLevels, secondLayerMenu) => {
    let navigationPath = `/${[baseLevel, ...subLevels.slice(0, index + 1)].join("/")}`;
    const lastPath = navigationPath.split("/").pop();
    if (secondLayerMenu.includes(lastPath)) {
      navigationPath = `/${[baseLevel, ...subLevels.slice(0, index)].join("/")}`;
    }
    navigate(navigationPath);
  };

  return (
    <>
      {!hideBreadCrumb && (
        <div className="hidden md:block w-full h-16 bg-brand">
          <WebContainer>
            <div className="w-full h-full flex items-center">
              <ul className="w-full h-full flex items-center">
                {subLevels.map((level, index, array) => {
                  return (
                    <li
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleNavigattion(
                          index,
                          baseLevel,
                          subLevels,
                          secondLayerMenu
                        );
                      }}
                      key={level + index}
                    >
                      <span
                        className={`text-body_base font-semibold ${
                          index === array.length - 1
                            ? "text-white"
                            : "text-red_200 "
                        } cursor-pointer`}
                      >
                        {level.toUpperCase()}
                      </span>
                      {index !== array.length - 1 && (
                        <span className="text-body_base font-semibold text-red_200 mx-3">
                          /
                        </span>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          </WebContainer>
        </div>
      )}
    </>
  );
};

export default Index;
